import React, { Component } from 'react';
// import {Link} from 'react-router-dom';
import {Image} from 'react-bootstrap';
//import { Card, CardImg, CardBody, CardTitle, CardText } from 'reactstrap';
//import Card from 'react-bootstrap/Card';
// import {Grid,Col,Image,Button, Row} from 'react-bootstrap';
import '../Styles/about.css';
import '../Styles/home.css';

export default class Varkala extends Component{
    render(){
        return(
            <div>                
                <div className="content-wrapper">    
                    <Image src="/assets/img/Varkala_beach.png" />
                                       
                </div>
                <div className="content-wrapper">    
                    <Image src="/assets/img/Varkala_abour.png" />
                                       
                </div>
            </div>
        )
    }
}